/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConversationParticipantRole {
    AGENCY = 'agency',
    TALENT_MANAGER = 'talentManager',
    SUPPORT = 'support',
    ADMIN_OBSERVER = 'adminObserver',
}
